export const TypeUpdateNoteEnum = Object.freeze({
    update: "update",
    create: "create",
    none:'none'
})